import React, { Fragment } from 'react';
import Input from '../../../layout/input/Input';
import InputTextArea from '../../../layout/input/InputTextArea';
import Panel from '../../../layout/panel/Panel';

class NossaHistoria extends React.Component {
    constructor(props) {
        super(props);
}

onChange(e, i) {        
    let lista = this.props.nossaHistoria;
    let opcao = lista[i];

    opcao[e.target.name] = e.target.value

    lista.splice(i, 1, opcao);
         
    this.props.onChangeForPropsNossaHistoria(lista);        
}  

    render(){
        return(
            <section id="nossaHistoria">
                {this.props.nossaHistoria.map((item, i) => (
                    <Panel 
                        key={i+1}
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        title={`Informação do ${i+1}° tópico da página`}
                    >
                        <Input
                                md={12}
                                key={i} 
                                xs={12} 
                                sm={12} 
                                lg={12}
                                id="titulo"
                                nome="titulo"
                                tooltip={`Insira o título que aparecerá no ${i+1}° tópico da Página Nossa História`}                       
                                value={item.titulo}                                            
                                onChange={(e) => this.onChange(e, i)}
                            >
                                Título
                            </Input>
                            <InputTextArea
                                md={12}
                                xs={12} 
                                sm={12} 
                                lg={12}
                                id="texto"
                                nome="texto" 
                                rows = {5}
                                tooltip={`Insira o texto que aparecerá no ${i+1}° tópico da Página Nossa História`}
                                value={item.texto} 
                                onChange={(e) => this.onChange(e, i)}                  
                            >
                                Texto                       
                            </InputTextArea>
                        </Panel>   
                ))}  
                </section>
        )
    }

}

export default NossaHistoria;